import Notifications from "components/Reusable/Notifications/Notifications.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import NotificationIcon from "../Notifications/NotificationIcon.js";
import Counter from "../Counter/Counter.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";

import { useState } from "react";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { UserLoggedOutSection } from "./UserLoggedOutSection.js";
import { UserLoggedInSection } from "./UserLoggedInSection.js";
import { useAppSelector } from "store/hooks.ts";
import { selectAllSearchParams } from "store/selectors/inboxSelectors.ts";

import "./UserNavigatorMenu.scss";
import "react-circular-progressbar/dist/styles.css";

const isInbox = window.location.pathname.includes("inbox");

const UserNavigatorMenu = ({
  isWhite,
  isMinified,
  countNewNotifications,
  setCountNewNotifications,
}) => {
  const { isLoggedIn, isTokenExist } = useUser();
  const { getTextByKey } = useContent();
  const [openNotifications, setOpenNotifications] = useState(false);
  const allSearchParams = useAppSelector(selectAllSearchParams);

  const { Desktop, mobileCondition, tabletCondition } = useMediaQueries();

  if (isTokenExist && !isLoggedIn()) return null;

  const generateLinkToInbox = () => {
    const searchParams = allSearchParams["all"];
    const searchParamsString = Object.keys(searchParams).reduce((acc, key) => {
      const isArray = Array.isArray(searchParams[key]);
      return searchParams[key]?.length && key !== "q"
        ? `${acc}&${key}=${
            isArray
              ? searchParams[key].filter((sp) => sp !== "saved").join(",")
              : searchParams[key]
          }`
        : acc;
    }, "");
    return `?t=all&pn=1&sortBy=date&asc=true&items=10&${searchParamsString}`;
  };

  return (
    <>
      <div className="user-navigator-menu" onClick={(e) => e.stopPropagation()}>
        {(mobileCondition || tabletCondition) && !isInbox && isLoggedIn() ? (
          <LinkToNewTab
            page={`inbox${generateLinkToInbox()}`}
            ariaLabel={getTextByKey("inbox")}
            classes="inbox-icon-wrapper"
          >
            <div className="inbox-icon">
              <i className="fas fa-envelope" />
            </div>
          </LinkToNewTab>
        ) : null}
        {isLoggedIn() && !isMinified ? (
          <NotificationIcon
            openNotifications={openNotifications}
            setOpenNotifications={setOpenNotifications}
            countNewNotifications={countNewNotifications}
          />
        ) : null}
        <Desktop>
          {isLoggedIn() && !isMinified ? (
            <div className="inbox-link">
              <LinkToNewTab
                page={`inbox${generateLinkToInbox()}`}
                ariaLabel={getTextByKey("inbox")}
              >
                {getTextByKey("inbox")}
                <Counter counterName="inboxPendingDownload" />
              </LinkToNewTab>
            </div>
          ) : null}
        </Desktop>
        {!isLoggedIn() ? (
          <UserLoggedOutSection isWhite={isWhite} />
        ) : (
          <UserLoggedInSection isWhite={isWhite} isMinified={isMinified} />
        )}
      </div>
      {!isMinified && (
        <Notifications
          openNotifications={openNotifications}
          setOpenNotifications={setOpenNotifications}
          setCountNewNotifications={setCountNewNotifications}
        />
      )}
    </>
  );
};
export default UserNavigatorMenu;
